import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import AutoComplete from 'Components/AutoComplete'
import onClickOutside from 'react-onclickoutside'
import { _LeadAutoComplete } from './styles'

const defaultPlaceHolder = 'Type user\'s first name, last name, or email'

/**
 Agent lead search autocomplete
 */
class LeadAutoComplete extends PureComponent {
  // eslint-disable-next-line react/no-unused-class-component-methods
  handleClickOutside(evt) {
    if(this.props.onBlur) this.props.onBlur(evt)
  }
  render() {
    const {
      typingStart,
      results,
      loadAutoComplete,
      handleUserSelect,
      placeHolder,
      closeSearch = () => {},
      sectionTitle = 'Leads',
      isFetching,
      autoFocus,
    } = this.props
    return (
      <_LeadAutoComplete>
        {
          <AutoComplete
            multiSection
            result={results ? { [sectionTitle]: results } : null}
            isFetching={isFetching}
            placeHolder={placeHolder || defaultPlaceHolder}
            loadAutoComplete={loadAutoComplete}
            typingStart={typingStart}
            closeSearch={closeSearch}
            onSuggestionSelect={handleUserSelect}
            autoFocus={autoFocus}
            source="home"
          />
        }
      </_LeadAutoComplete>
    )
  }
}


LeadAutoComplete.propTypes = {
  typingStart: PropTypes.func,
  results: PropTypes.arrayOf(PropTypes.shape({})),
  loadAutoComplete: PropTypes.func,
  handleUserSelect: PropTypes.func,
  placeHolder: PropTypes.string,
  closeSearch: PropTypes.func,
  sectionTitle: PropTypes.string,
  isFetching: PropTypes.bool,
  onBlur: PropTypes.func,
  autoFocus: PropTypes.bool,
}
export default onClickOutside(LeadAutoComplete)
